
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FeedbackButtonComponent } from '@common/feedback/frontend';
import { MembershipFrontendSharedModule } from '@common/membership/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiCardBundle } from '@common/ui/frontend-shared/card';
import { UiInputDropdownBundle } from '@common/ui/frontend-shared/input-dropdown';
import { UiTabViewBundle } from '@common/ui/frontend-shared/tabview';
import { UserAuthenticationStrategiesComponent } from '@common/users/frontend-shared';
import { AccessState, CoreFrontendSharedModule } from '@core/frontend-shared';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { LayoutFrontpageComponent } from '@mpf/ui/frontend-shared/layout-frontpage';
import { Store } from '@ngxs/store';

@Component({
    selector: 'mpf-login',
    styleUrls: ['./login.component.scss'],
    template: `
	<mpf-layout-frontpage theme="green">
	<!-- <a class="top-menu-item" routerLink="/privacy" >Datenschutz</a>
		<a class="top-menu-item" routerLink="/imprint" >Impressum</a> -->
		<feedback-button class="top-menu-item"  buttonClass=""></feedback-button>	

		<div class="content-left">
			<h2>Die <b>einfache Lösung</b><br> für Ihr Team.</h2>
		</div>
		<div class="content-right">
			<div>
				<div class="login">
					<h2 class="margin">Login</h2>
					<user-authentication-strategies></user-authentication-strategies>
				</div>
				<hr style="margin:30px 0">
				<div >
					<h2 class="margin">Registrierung</h2>
					<p>Sie haben noch keinen Zugang? Kein Problem!</p>
		
					<div class="contact-info ui-margin-medium" uiGrid>
						<div class="p-col-fixed" style="width:230px">
							<a [routerLink]="'request-demo'|resolveRouterLink" iconPos="right" uiButton icon="arrow-right" label="Jetzt gratis testen" class="ui-button-outline"></a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ui-card size="large">
		</ui-card>
	</mpf-layout-frontpage>
	`,
    imports: [
    UiCardBundle,
    UiButtonComponent,
    RouterModule,
    LayoutFrontpageComponent,
    FeedbackButtonComponent,
    UiInputDropdownBundle,
    CoreFrontendSharedModule,
    UiTabViewBundle,
    MembershipFrontendSharedModule,
    UserAuthenticationStrategiesComponent
]
})
export class AppLoginComponent {

	loggedIn$ = inject(Store).select(AccessState.loggedIn) 

	constructor(
		store:Store,
		router:Router
	) {
		
		// navigate to home if user is already logged in
		this.loggedIn$.pipe(takeWhileAlive()).subscribe(loggedIn=>{
			if(loggedIn) router.navigate(['/'])
		})
	}

}
